// Static KRX ticker → 한글 종목명 map, mirror of
// internal/watchlist/krx_names.go. Kept on the client so every site
// that renders a ticker ("005930", "035720") can also show the name
// ("삼성전자", "카카오") without a per-row network call.
//
// Extend this + the Go copy together. Missing entries render as bare
// ticker — never-worse-than-before fallback.

export const KRX_NAMES: Record<string, string> = {
  // KOSPI heavyweights
  '005930': '삼성전자',
  '000660': 'SK하이닉스',
  '005380': '현대차',
  '000270': '기아',
  '005935': '삼성전자우',
  '006400': '삼성SDI',
  '051910': 'LG화학',
  '035420': 'NAVER',
  '035720': '카카오',
  '068270': '셀트리온',
  '207940': '삼성바이오로직스',
  '028260': '삼성물산',
  '012330': '현대모비스',
  '096770': 'SK이노베이션',
  '373220': 'LG에너지솔루션',
  '003550': 'LG',
  '066570': 'LG전자',
  '105560': 'KB금융',
  '055550': '신한지주',
  '086790': '하나금융지주',
  '024110': '기업은행',
  '316140': '우리금융지주',
  '138040': '메리츠금융지주',
  '034020': '두산에너빌리티',
  '009540': 'HD한국조선해양',
  '329180': 'HD현대중공업',
  '010130': '고려아연',
  '011170': '롯데케미칼',
  '017670': 'SK텔레콤',
  '030200': 'KT',
  '032640': 'LG유플러스',
  '009150': '삼성전기',
  '018260': '삼성에스디에스',
  '010950': 'S-Oil',
  '015760': '한국전력',
  '036570': '엔씨소프트',
  '251270': '넷마블',
  '112040': '위메이드',
  '259960': '크래프톤',
  '293490': '카카오게임즈',
  '035900': 'JYP Ent.',
  '041510': 'SM',
  '352820': '하이브',
  '122870': '와이지엔터테인먼트',
  '024720': '콜마비앤에이치',
  '090430': '아모레퍼시픽',
  '161890': '한국콜마',
  '097950': 'CJ제일제당',
  '271560': '오리온',
  '004990': '롯데지주',
  '000080': '하이트진로',
  '033780': 'KT&G',
  '139480': '이마트',
  '021240': '코웨이',
  '034730': 'SK',
  '034220': 'LG디스플레이',
  '028050': '삼성E&A',
  '042660': '한화오션',
  '267260': 'HD현대일렉트릭',
  '005490': 'POSCO홀딩스',
  '047050': '포스코인터내셔널',
  '003670': '포스코퓨처엠',
  '011200': 'HMM',
  '003490': '대한항공',
  '180640': '한진칼',
  '010140': '삼성중공업',
  '009830': '한화솔루션',
  '000880': '한화',
  '010060': 'OCI홀딩스',
  '093370': '후성',
  '011780': '금호석유',
  '086280': '현대글로비스',
  '012630': 'HDC',
  '294870': 'HDC현대산업개발',
  '042670': 'HD현대인프라코어',
  '267250': 'HD현대',
  '003030': '세아제강지주',
  '004020': '현대제철',
  '069960': '현대백화점',
  '023530': '롯데쇼핑',
  '006800': '미래에셋증권',
  '008560': '메리츠증권',
  '016360': '삼성증권',
  '030610': '교보증권',
  '078930': 'GS',
  '001040': 'CJ',
  '005440': '현대그린푸드',
  '097230': 'HJ중공업',
  // KOSDAQ
  '091990': '셀트리온헬스케어',
  '196170': '알테오젠',
  '247540': '에코프로비엠',
  '086520': '에코프로',
  '091700': '파트론',
  '039030': '이오테크닉스',
  '036830': '솔브레인홀딩스',
  '240810': '원익IPS',
  '042700': '한미반도체',
  '058470': '리노공업',
  '064350': '현대로템',
  '067310': '하나마이크론',
  '348370': '엔켐',
  '141080': '리가켐바이오',
  '137310': '에스디바이오센서',
  '328130': '루닛',
  '214150': '클래시스',
  '214450': '파마리서치',
  '278280': '천보',
  '131970': '테스나',
  '357780': '솔브레인',
  '039490': '키움증권',
  '145020': '휴젤',
  '122640': '예스24',
  '089030': '테크윙',
  '277810': '레인보우로보틱스',
  '052400': '코나아이',
  '095660': '네오위즈',
  '299900': '위메이드맥스',
  '226400': '오스테오닉',
  '950140': '잉글우드랩',
  '196300': '에스티팜',
  '067630': 'HLB생명과학',
  '028300': 'HLB',
  '950170': 'JTC',
  '950210': '프레스티지바이오파마',
  '307950': '현대오토에버',
  '006360': 'GS건설',
  '000720': '현대건설',
  '047810': '한국항공우주',
  '272210': '한화시스템',
  '079550': 'LIG넥스원',
  '064960': 'SNT모티브',
  '001450': '현대해상',
  '003690': '코리안리',
  '000810': '삼성화재',
  '032830': '삼성생명',
  '088350': '한화생명',
  '001800': '오리온홀딩스',
  '000240': '한국앤컴퍼니',
  '161390': '한국타이어앤테크놀로지',
  '002380': 'KCC',
  '006260': 'LS',
  '010620': 'HD현대미포',
  '006650': '대한유화',
  '001680': '대상',
  '004370': '농심',
  '005300': '롯데칠성',
  '000100': '유한양행',
  '069620': '대웅제약',
  '003090': '대웅',
  '128940': '한미약품',
  '008930': '한미사이언스',
  '185750': '종근당',
  '098460': '고영',
  '007810': '코리아써키트',
  '032500': '케이엠더블유',
  '950130': '엑세스바이오',
  '237690': '에스티큐브',
  '066970': '엘앤에프',
  '004800': '효성',
  '298020': '효성티앤씨',
}

/** Look up a KRX ticker in the static map. Empty string when missing
 *  so call-sites can `name || ticker` fallback. */
export function krxName(ticker?: string | null): string {
  if (!ticker) return ''
  return KRX_NAMES[ticker] ?? ''
}

/** Format helper — "005930 삼성전자" when known, bare ticker otherwise. */
export function tickerWithName(ticker?: string | null): string {
  if (!ticker) return ''
  const name = KRX_NAMES[ticker]
  return name ? `${ticker} ${name}` : ticker
}

// Crypto (Bithumb) KRW-* symbol → 한글 코인명. Covers the universe
// the auto-trade session actually watches (top KRW pairs). Missing
// entries fall through to the bare symbol so a new listing doesn't
// crash the UI.
const CRYPTO_NAMES: Record<string, string> = {
  'KRW-BTC':   '비트코인',
  'KRW-ETH':   '이더리움',
  'KRW-XRP':   '리플',
  'KRW-SOL':   '솔라나',
  'KRW-DOGE':  '도지코인',
  'KRW-ADA':   '에이다',
  'KRW-MATIC': '폴리곤',
  'KRW-DOT':   '폴카닷',
  'KRW-AVAX':  '아발란체',
  'KRW-LINK':  '체인링크',
  'KRW-TRX':   '트론',
  'KRW-LTC':   '라이트코인',
  'KRW-BCH':   '비트코인캐시',
  'KRW-ATOM':  '코스모스',
  'KRW-NEAR':  '니어프로토콜',
  'KRW-ARB':   '아비트럼',
  'KRW-OP':    '옵티미즘',
  'KRW-SUI':   '수이',
  'KRW-APT':   '앱토스',
  'KRW-SHIB':  '시바이누',
  'KRW-PEPE':  '페페',
  'KRW-USDT':  '테더',
  'KRW-USDC':  'USD코인',
  'KRW-ETC':   '이더리움클래식',
  'KRW-XLM':   '스텔라루멘',
  'KRW-BNB':   '바이낸스코인',
  'KRW-WAVES': '웨이브',
  'KRW-QTUM':  '퀀텀',
  'KRW-EOS':   '이오스',
  'KRW-FIL':   '파일코인',
  'KRW-HBAR':  '헤데라',
}

/** symbolName resolves a name across all asset classes the UI can
 *  render: 6-digit KRX tickers, Bithumb KRW-* coins, and Nasdaq /
 *  NYSE alphabetic tickers (which we expose as-is — the symbol IS
 *  the name in US-market UX). Returns empty string when the symbol
 *  is unknown so callers can `name || symbol` fallback. */
export function symbolName(symbol?: string | null): string {
  if (!symbol) return ''
  const s = symbol.trim()
  if (/^\d{6}$/.test(s)) return KRX_NAMES[s] ?? ''
  if (s.startsWith('KRW-')) return CRYPTO_NAMES[s] ?? ''
  // US-market tickers (AAPL, MSFT, …) carry their identity in the
  // symbol itself; there's no separate korean rendering to surface.
  return ''
}

/** Format helper — "005930 삼성전자" / "KRW-BTC 비트코인", bare
 *  symbol when the name lookup misses. Used by tabular displays that
 *  prefer a single-string column over a two-column layout. */
export function symbolWithName(symbol?: string | null): string {
  if (!symbol) return ''
  const name = symbolName(symbol)
  return name ? `${symbol} ${name}` : symbol
}
